import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { ILoteLojaForm } from "../../../../types/loteAgendamento";

export const useVincularLojaLoteAgendamento = () => {
  return useMutation({
    mutationFn: (data: ILoteLojaForm) => LoteAgendamento.vincularLoja(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
